export const LOADING = 'LOADING';
export const OK = 'OK';
export const WRONG = 'WRONG';
export const CONNECT = 'CONNECT';
export const INSTALL = 'INSTALL';

export const SET_FOOTER_DATA = 'SET_FOOTER_DATA';
export const SET_MANAGE_DATA = 'SET_MANAGE_DATA';
export const SET_WORKLOCK_DATA = 'SET_WORKLOCK_DATA';
export const SET_ACTION_HISTORY_DATA = 'SET_ACTION_HISTORY_DATA'

export const SET_ACCOUNT_AND_NU = 'SET_ACCOUNT_AND_NU';
export const SET_WALLET = 'SET_WALLET';

export const SET_SHOW_RESTAKE_LOADER = 'SET_RESTAKE_CLICKED';
export const SET_RESTAKE_STATUS = 'SET_RESTAKE_STATUS';
export const SET_SHOW_WINDDOWN_LOADER = 'SET_WINDDOWN_CLICKED';
export const SET_WINDDOWN_STATUS = 'SET_WINDDOWN_STATUS';

export const SET_WORKER_LOADER = 'SET_WORKER_LOADER';
export const SET_WORKER_ADDRESS = 'SET_WORKER_ADDRESS';

export const SET_DIVIDE_LOADER = 'SET_DIVIDE_LOADER';
export const SET_PROLONG_LOADER = 'SET_PROLONG_LOADER';

export const SET_WITHDRAW_NU_LOADER = 'SET_WITHDRAW_NU_LOADER';
export const SET_WITHDRAW_POLICY_LOADER = 'SET_WITHDRAW_ETH_LOADER';

